import VueI18n from 'vue-i18n'
import Vue from 'vue'
import messages from './translate'

Vue.use(VueI18n)
// console.log(JSON.stringify(messages))

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

export default {
  i18n
};



// WEBPACK FOOTER //
// ./src/local/i18n.js